<template>
  <div class="user">
    <header-top :headerPosition="false">
      <div slot="title">爱心充值协议</div>
    </header-top>
    <div class="user-wrapper">
      <div class="user-title">特别提示</div>
      <div class="user-content">
        成都陌陌科技有限公司（以下简称“{{ appName }}”）在此特别提醒您，在您开始使用充值服务之前，请认真阅读《爱心充值协议》（以下简称“本协议”），确保您充分理解各条款，包括免除{{ appName }}责任的条款及限制您权利的条款。限制或免除责任条款可能以黑体加粗形式提示您注意，您应重点阅读。请您审慎阅读并选择接受或不接受本协议。除非您接受本协议所有条款，否则您不要使用本协议所涉服务。如您自主选择按照页面提示完成充值程序将视为对本协议的接受，并同意接受各项条款的约束。
      </div>
      <div class="user-content">
        本协议是基于{{ appName }}平台的《用户协议》而制定，是其不可分割的一部分。本协议可由{{ appName }}随时更新，更新后的协议一旦公布即代替原来的协议内容，恕不再另行通知，您可在App内查阅最新版本。
      </div>
      <div class="user-content">
        如您为无民事行为能力人或限制民事行为能力人，请告知您的监护人，并在您监护人的指导下阅读本协议和使用充值服务，并征得监护人同意后使用我们的服务。
      </div>
      <div class="user-title">一、服务规则</div>
      <div class="user-content">
        1.
        “爱心”是{{ appName }}向您提供的用于在{{ appName }}平台上进行相关消费的虚拟货币，您可以用“爱心”购买{{ appName }}平台的增值服务，包括但不限于虚拟礼物服务（具体可购买产品和服务请查看相应产品、服务页面说明），除此外，不得用于其他任何用途。该等增值服务的价格均以“爱心”为单位，具体价格信息将由{{ appName }}自行决定并在相关服务页面上显示。
      </div>
      <div class="user-content">
        2.
        “爱心”和人民币的兑换比例依您购买渠道的不同而有不同的兑换比例，具体兑换比例以您购买“爱心”相关渠道服务页面显示为准。{{ appName }}有权根据运营情况随时变更上述兑换比例，并将在您购买“爱心”相关渠道服务页面显示，请您务必注意各充值方式的渠道商服务手续费，并按自身需求选取充值方式。
      </div>
      <div class="user-content">
        3.
        您默认已开通“爱心”账户，可进行“爱心”购买（下称“充值”）和消费。您可在设置页面查询到“爱心”余额、购买记录和消费记录。“爱心”相关信息将不作为公开信息。如您对上述记录有异议，应立即向{{ appName }}平台提出，{{ appName }}平台调查核对后确有错误的，将予以更正。否则您同意{{ appName }}平台上的充值记录将作为“爱心”充值及余额的唯一有效依据。
      </div>
      <div class="user-content">
        4.
        您可以通过微信、支付宝或其他{{ appName }}平台提供的充值途径为“爱心”账户进行充值。您使用“爱心”购买相关收费服务后，可将相关收费服务赠与其他用户。您确认不会以非法方式或者使用非平台所指定的充值途径进行充值,如果您违规使用非{{ appName }}认可的充值途径非法充值/购买“爱心”或者利用不同渠道的漏洞进行恶意退费，则{{ appName }}不保证充值顺利或正确完成，同时可能引发其他风险，若因此造成您或任何第三方的权益受损，由您自行应对处理并承担相应责任，{{ appName }}将不会作出任何补偿或赔偿，{{ appName }}同时保留随时中止或终止您{{ appName }}账号部分或全部权限、冻结您的账户余额、短期或永久封禁您的账号及/或禁止您使用各项充值服务的权利。
      </div>
      <div class="user-content">
        5.
        使用充值服务时，您应确保您是该充值账号的权利人，可合法、有效使用该账号且未侵犯任何第三方合法权益，否则因此造成充值账户实际所有人损失的，您应单独负责解决由此产生的纠纷并承担全部法律责任。
      </div>
      <div class="user-content">
        6.
        您确认在进行充值前已经仔细确认过自己的账号并仔细选择及/或输入了充值账号、充值金额等相关操作选项，若因您自身输入账号错误、金额错误、操作不当或不了解、未充分了解充值计费方式等因素造成充错账号、充值金额错误、错选充值种类等情形而损害自身权益的，由此带来的损失由您自行承担，{{ appName }}将不会作出任何补偿或赔偿。
      </div>
      <div class="user-content">
        7.
        您同意并确认，“爱心”属于数字化产品，因其特殊属性不适用《中华人民共和国消费者权益保护法》中有关七天无理由退货条款的约束。一旦购买成功，您账号内的“爱心”可由您在本服务中自由使用，除法律规定的情形及本协议另有约定外，{{ appName }}不会提供任何“爱心”退款或逆向兑换服务，请您根据自己的实际需求购买相应数量的“爱心”。
      </div>
      <div class="user-content">
        8.
        如果{{ appName }}发现因系统故障或其他任何原因导致的处理错误，无论有利于{{ appName }}还是有利于您，{{ appName }}都有权纠正该错误。如果该措施导致您实际收到的“爱心”数量少于您应获得的“爱心”，则{{ appName }}在确认该处理错误后会尽快将差额补足至您的账户中。如果该错误导致您实际收到的“爱心”数量多于您应获得的“爱心”，则无论错误的性质和原因如何，{{ appName }}有权从您的账户中直接扣除差额。
      </div>
      <div class="user-content">
        9.
        您确认，“爱心”只能用于购买{{ appName }}平台上的各类增值服务，任何情况下不得违规私下进行“爱心”交易，不能在用户之间相互转移，如违反前述约定，造成用户或第三方任何损失，{{ appName }}不负任何责任，且如{{ appName }}有理由怀疑您的“爱心”账户或使用情况有作弊或异常状况，{{ appName }}将拒绝该您使用“爱心”进行支付，直至按本协议约定采取相关封禁措施。
      </div>
      <div class="user-content">
        10.
        为更好的向用户提供产品服务，{{ appName }}会收集记录您充值购买“爱心”并在本服务中使用“爱心”所产生的数据，包括但不限于用户充值、购买虚拟礼物等产品或服务及其他在本服务中使用“爱心“所产生的行为信息，以及您的账号、背包内未打赏礼物、”爱心“余额等账号信息。
      </div>
      <div class="user-content">
        11.
        您确认并同意如您主动注销账号，则您已充值到账的“爱心“，购买的虚拟礼物等视为自动放弃，{{ appName }}不予返还相应的现金价值，也不会作出任何补偿。
      </div>
      <div class="user-content">
        12.
        如根据国家法律法规规定，{{ appName }}平台需要向您开具发票的，请根据相关指引申请开票。{{ appName }}平台有权在法律允许的范围内选择开票形式。您可在“爱心“消费后向{{ appName }}平台申请开票，发票由{{ appName }}或其关联方向您开具。
      </div>
      <div class="user-title">二、权利声明</div>
      <div class="user-content">
        1.
        您理解并同意，{{ appName }}有权基于交易安全、运营策略、行业惯例等方面的考虑不时设定或修改涉及交易的相关事项，包括但不限于交易限额、交易次数等。
      </div>
      <div class="user-content">
        2.
        因您自身的原因导致{{ appName }}无法提供“爱心“购买服务或提供”爱心“购买服务时发生任何错误而产生的任何损失或责任，由您自行负责，{{ appName }}不承担责任，包括但不限于：
      </div>
      <div class="user-content">
        （1） 您未按照本协议或{{ appName }}不时公布和更新的规则进行充值服务操作；
      </div>
      <div class="user-content">（2） 因您的{{ appName }}账号丢失、被封禁或冻结；</div>
      <div class="user-content">（3） 您将密码告知他人导致的财产损失；</div>
      <div class="user-content">
        （4） 因您自身输入账号错误、操作不当等因素造成充错账号、错选充值种类、错选充值金额；
      </div>
      <div class="user-content">（5） 因您绑定的第三方支付机构账户的原因导致的任何损失或责任；</div>
      <div class="user-content">（6） 其他用户故意或者重大过失或者违反法律法规导致的财产损失。</div>
      <div class="user-content">
        3.
        因下列状况导致您无法使用{{ appName }}平台的充值服务或使您的任何虚拟财产丢失时，您同意{{ appName }}平台无须承担损害赔偿责任，该状况包括但不限于：
      </div>
      <div class="user-content">（1）在{{ appName }}平台公告之系统停机维护、升级、调整期间；</div>
      <div class="user-content">（2）电信通讯或设备出现故障不能进行数据传输的；</div>
      <div class="user-content">
        （3）因台风、地震、海啸、洪水、停电、战争、恐怖袭击、政府管制等不可抗力之因素，造成{{ appName }}平台系统障碍不能执行业务的；
      </div>
      <div class="user-content">
        （4）由于黑客攻击、电信部门技术调整或故障、网站升级、相关第三方的问题等原因而造成的服务中断或者延迟。
      </div>
      <div class="user-content">
        4.
        如充值过程中涉及由第三方提供的相关服务，则除遵守本协议约定外，您还需要同意并遵守该等第三方的协议及相关规则，在任何情况下，对于该第三方及其提供的相关服务而产生的争议由您自行与该第三方解决，{{ appName }}无需就此向您或该第三方承担任何责任。
      </div>
      <div class="user-content">
        5.
        您保证用于“爱心”充值的资金均为您的合法收入所得，且您有充分权利按照本协议约定使用，因您违反本条而产生的任何争议或纠纷，由您自行处理解决，并承担由此带来的全部责任及法律后果。同时，如果{{ appName }}发现（包括但不限于主动发现、收到第三方投诉或权力机关通知等情形）存在上述事由，有权单方决定限制您使用全部或部分充值“爱心”、暂停或终止向您提供充值服务或对您的账号采取进一步管理措施；如因此给{{ appName }}造成损失的，您应予以全额赔偿，同时，{{ appName }}有权保存相关信息，并向相关执法/司法机构、主管部门报告。
      </div>
      <div class="user-content">
        6.
        您不得通过{{ appName }}充值进行任何违法犯罪活动，否则{{ appName }}有权终止服务，情节严重的，依法移交司法机关。
      </div>
      <div class="user-content">
        7.
        在任何情况下，{{ appName }}均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害承担责任。{{ appName }}对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您因使用{{ appName }}平台提供的充值服务而支付的费用。
      </div>

      <div class="user-title">三、服务变更</div>
      <div class="user-content">
        1.
        为了向您提供更好的服务，或者基于法律规定、主管部门要求、业务开展情况等因素的更新与变化，{{ appName }}可以随时变更服务或更新本协议的条款。修改后的服务协议一旦在页面上公布即代替原来的服务协议。您可通过充值页面查阅最新充值协议。若您在本协议内容发生修订后继续使用本平台提供的充值服务的，则视为您同意最新修订的协议内容；否则请您立即停止充值。
      </div>
      <div class="user-content">
        2. 如因系统维护或升级的需要而需暂停充值服务，{{ appName }}将尽可能事先进行通告。
      </div>
      <div class="user-content">
        .
        {{ appName }}因政策、行政监管等原因可能中止、中断或终止“爱心“已经购买的部分或全部服务/产品。如有此情形发生，{{ appName }}平台会尽可能的通过采取公告或站内信的形式通知您，但不承担由此给您造成的任何损失。
      </div>
      <div class="user-content">
        4.
        除前述情况外，{{ appName }}平台有权视交易安全、运营规划等具体情况随时中断、中止或终止本协议项下充值服务，并将以{{ appName }}平台页面公告或其他适当方式向用户发出通知（而不再另行单独通知您），对于充值服务的中断或终止而造成的任何损失，{{ appName }}无需对您或任何第三方承担任何责任。
      </div>
      <div class="user-content">
        5.
        您理解并同意，{{ appName }}平台提供的充值服务是按照现有技术和条件所能达到的现状提供的，{{ appName }}平台会尽最大努力向您提供充值服务，确保充值服务的连贯性和安全性。但您亦知悉并认可，{{ appName }}平台不能随时或始终预见和防范技术及其他风险，包括但不限于因不可抗力、网络原因、第三方服务瑕疵、第三方网站等原因可能导致的服务中断、不能正常使用充值服务以及其他的损失和风险。
      </div>

      <div class="user-title">四、处罚规则</div>
      <div class="user-content">
        1.
        如发生下列任何一种情形，{{ appName }}有权随时中断或终止向您提供本协议项下的充值服务而无需通知您，且无需承担因充值服务中断或终止而给您或任何第三方造成损失的任何责任：
      </div>
      <div class="user-content">（1） 您提供的个人资料不真实；</div>
      <div class="user-content">
        （2） 您违反本协议、《用户协议》、《{{ appName }}平台行为规范》或其他本平台对用户的管理规定；
      </div>
      <div class="user-content">（3） 您通过“黑产“等不正当手段进行充值行为；</div>
      <div class="user-content">（4） 您以非法目的购买、使用“爱心”；</div>
      <div class="user-content">（5） 您的账号被用于恶意退费等非法违规行为。</div>
      <div class="user-content">
        2.
        如您实施了下列任何一种行为，{{ appName }}有权视严重情况对您同时采取各种合理措施进行处罚而无需通知您，同时{{ appName }}无须给予您任何补偿和退费、不予返还您购买“爱心”所支付的对价，由此产生的责任由您自行独立承担。因此给{{ appName }}或第三方造成损失的，您应负责全额赔偿（包括但不限于赔偿金、罚金、和解费、诉讼仲裁费、合理的律师费支出等）：
      </div>
      <div class="user-content">（1） 以营利为目的为自己或他人获得充值服务的；</div>
      <div class="user-content">（2） 将通过充值服务获得的“爱心“用于本协议约定之外用途的；</div>
      <div class="user-content">（3） 盗用他人账号进行充值服务及/或购买或使用的；</div>
      <div class="user-content">
        （4）
        以任何系统BUG、漏洞、机器人软件、蜘蛛软件、爬虫软件、刷屏软件或其它非正规方式获得充值服务的；
      </div>
      （
      <div class="user-content">
        5） 其他通过不正当手段或以违反诚实信用原则的行为获得充值服务的。
      </div>
      <div class="user-content">
        3.
        您同意保障和维护{{ appName }}及其他用户的利益，如因您违反有关法律法规或本协议项下的任何条款而给{{ appName }}或任何其他第三方造成损失，您同意承担由此造成的损害赔偿责任。同时，{{ appName }}公司有权采取以下一项或多项措施，包括但不限于：
      </div>
      <div class="user-content">（1） 暂停或终止提供全部或部分{{ appName }}服务；</div>
      <div class="user-content">（2） 暂时限制或永久封禁您的{{ appName }}账号；</div>
      <div class="user-content">（3） 对相关您账户中全部或部分的“爱心”余额进行冻结或回收；</div>
      <div class="user-content">4. 发生下列情况时，{{ appName }}免于承担任何法律责任：</div>
      <div class="user-content">（1） 您因使用第三方支付渠道充值过程中发生的相关争议；</div>
      <div class="user-content">（2） 由于您将密码告知他人导致的财产损失；</div>
      <div class="user-content">
        （3） 因您个人故意或重大过失，或本协议之外的第三方所造成的财产损失；
      </div>
      <div class="user-content">
        （4）
        由不可抗力及不可预见的情势导致的各种情况和纠纷；不可抗力和不可预见情势包括：黑客攻击、电信部门技术调整导致重大影响、政府管制导致的暂时关闭、病毒侵袭等。
      </div>
      <div class="user-content">
        5.
        {{ appName }}严禁通过未经授权的任何渠道或利用违法违规违反服务协议的方式（包括但不限于利用支付漏洞等）获取“爱心“，以前述非法方式获得的”爱心“及所购物品，{{ appName }}平台有权随时回收且无需返还任何款项，因使用前述非法方式获取的”爱心“所取得的服务及效果无效，将会被清除。
      </div>
      <div class="user-content">
        6.
        您在使用充值服务时，如出现任何的涉嫌犯罪、违法违规、违反社会主义道德风尚、违反《用户协议》、本协议或其他本服务对用户的管理规定的情形，{{ appName }}有权视您行为的性质及严重程度决定对您的账号采取暂时或永久封禁措施。账号封禁后至解禁（如有）前，您账户上剩余的“爱心“将被冻结或全部扣除，不可继续用于购买本服务提供的任何产品或服务，{{ appName }}不予返还您购买”爱心“时的现金价值，也不会作出任何补偿。
      </div>

      <div class="user-title">五、附则</div>
      <div class="user-content">
        1. {{ appName }}不时发布的关于充值服务的规范、规则等（如有），是本协议不可分割的一部分。
      </div>
      <div class="user-content">
        2.
        本协议未约定事项，参照《用户协议》执行；本协议约定与《用户协议》不一致的，以本协议的约定为准。
      </div>
      <div class="user-content">
        3.
        本协议的解释，效力及纠纷的解决，适用中华人民共和国法律。若您和{{ appName }}之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖，本协议签订地为北京市朝阳区。
      </div>

      <div class="user-content">
        4.
        {{ appName }}不行使、未能及时行使或者未充分行使本协议或者按照法律规定所享有的权利，不应被视为放弃该权利，也不影响{{ appName }}在将来行使该权利。
      </div>
      <div class="user-content">
        5.
        若本协议之任何规定因与中华人民共和国法律抵触或被有管辖权的人民法院认定而无效或不可执行，则在不违反法律的前提下，这些条款将按照尽可能接近本协议原条文意旨的原则重新解析，且本协议其它规定仍应具有完整的效力及效果。
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.user-wrapper {
  padding-top: 120px;
  padding: 120px 30px 0 30px;
  width: 690px;
  text-align: left;
}
.user-title {
  margin-bottom: 40px;
  font-family: "PingFangSC-Medium";
  font-size: 30px;
  color: rgb(63, 68, 111);
}
.user-content {
  font-size: 26px;
  color: #3f446f;
  line-height: 41px;
  padding-bottom: 40px;
}
.user {
  background-color: #f6f5fb;
}
</style>
<script>
import HeaderTop from "src/components/HeaderTop.vue";

export default {
  name: "recharge",
  data() {
    return {
      appName: this.$store.state.appName
    };
  },
  components: {
    "header-top": HeaderTop // 顶部导航组件
  }
};
</script>
